import { render, staticRenderFns } from "./InputModal.vue?vue&type=template&id=181d36f5&scoped=true"
import script from "./InputModal.vue?vue&type=script&lang=js"
export * from "./InputModal.vue?vue&type=script&lang=js"
import style0 from "./InputModal.vue?vue&type=style&index=0&id=181d36f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d36f5",
  null
  
)

export default component.exports